import { logEvent } from 'firebase/analytics';
import { analytics } from '@/services/firebase';

export const customEvents = {
  SIGNED_UP_COMING_FROM_INSTAGRAM: 'signed_up_coming_from_instagram',
  SIGNUP: 'signup',
  FIRST_LINK_ADDED: 'first_link_added',
  WAITLIST_SIGNUP: 'waitlist_signup',
};

export default {
  namespaced: true,
  actions: {
    emitInstagramEvent({ dispatch }) {
      try {
        const from = localStorage.getItem('userCameFrom');
        if (from === 'instagram') {
          logEvent(analytics, customEvents.SIGNED_UP_COMING_FROM_INSTAGRAM);
          localStorage.removeItem('userCameFrom');
        }
      } catch (e) {
        dispatch('errorOverlay/setMessage', e, { root: true });
      }
    },
    emitSignupEvent() {
      try {
        logEvent(analytics, customEvents.SIGNUP);
      } catch (e) {
        console.error(e);
      }
    },
  },
};
